 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"channelStoriesPage-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage":"channelStoriesPage-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage","channelStoriesPage":"channelStoriesPage","mobile403":"mobile403","mobileExploreCategoryPage":"mobileExploreCategoryPage","mobileExploreResultsPage-mobileSearchResultsPage":"mobileExploreResultsPage-mobileSearchResultsPage","mobileExploreResultsPage":"mobileExploreResultsPage","mobileSearchResultsPage":"mobileSearchResultsPage","mobileFavoritesPage":"mobileFavoritesPage","mobileResetPasswordPage":"mobileResetPasswordPage","mobileTrendingPage":"mobileTrendingPage","vendors-gifEditPanel-gifMakerFinalize":"vendors-gifEditPanel-gifMakerFinalize","vendors-gifEditPanel":"vendors-gifEditPanel","gifEditPanel":"gifEditPanel","vendors-gifMakerFinalize-mobile404-mobileChangePasswordPage-mobileChannelBranchPage-mobileChannelLea-f93ae832":"vendors-gifMakerFinalize-mobile404-mobileChangePasswordPage-mobileChannelBranchPage-mobileChannelLea-f93ae832","gifMakerFinalize-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage":"gifMakerFinalize-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage","mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage":"mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage","mobileChannelBranchPage":"mobileChannelBranchPage","mobileChannelLeafPage":"mobileChannelLeafPage","mobileChannelListPage":"mobileChannelListPage","mobileChannelPage":"mobileChannelPage","mobileApplyPage-mobileChangePasswordPage-mobileJoinPage-mobileLoginPage-mobileSettingsPage":"mobileApplyPage-mobileChangePasswordPage-mobileJoinPage-mobileLoginPage-mobileSettingsPage","mobileChangePasswordPage":"mobileChangePasswordPage","vendors-desktopVideoDetail-desktopVideos-mobile404":"vendors-desktopVideoDetail-desktopVideos-mobile404","desktopVideoDetail-desktopVideos-mobile404":"desktopVideoDetail-desktopVideos-mobile404","mobile404":"mobile404","vendors-mobileApplyPage-mobileGifMaker-mobileSettingsPage":"vendors-mobileApplyPage-mobileGifMaker-mobileSettingsPage","vendors-gifMakerFinalize-mobileGifMaker":"vendors-gifMakerFinalize-mobileGifMaker","vendors-mobileGifMaker":"vendors-mobileGifMaker","mobileGifMaker":"mobileGifMaker","vendors-mobileJoinPage-mobileLoginPage":"vendors-mobileJoinPage-mobileLoginPage","mobileJoinPage-mobileLoginPage":"mobileJoinPage-mobileLoginPage","mobileJoinPage":"mobileJoinPage","mobileLoginPage":"mobileLoginPage","mobileApplyPage-mobileSettingsPage":"mobileApplyPage-mobileSettingsPage","mobileApplyPage":"mobileApplyPage","mobileSettingsPage":"mobileSettingsPage","vendors-mobileDashboard":"vendors-mobileDashboard","mobileDashboard":"mobileDashboard","vendors-mobileTeamPage":"vendors-mobileTeamPage","mobileTeamPage":"mobileTeamPage","vendors-showdown":"vendors-showdown","desktopVideoDetail":"desktopVideoDetail","desktopVideos":"desktopVideos","creationAnimate":"creationAnimate","creationCutOut":"creationCutOut","desktopUploadFinalize":"desktopUploadFinalize","gifMakerSlideshow":"gifMakerSlideshow","gifMakerVideoTrim":"gifMakerVideoTrim","gifMakerFinalize":"gifMakerFinalize","aboutPage":"aboutPage","appsLanding":"appsLanding","artists":"artists","curationStation":"curationStation","desktopChannelStories":"desktopChannelStories","desktopStory":"desktopStory","homebase":"homebase","homepageBeta":"homepageBeta"}[chunkId]||chunkId) + "." + {"0":"72d4e808","channelStoriesPage-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage":"06994e6e","channelStoriesPage":"94fef74c","mobile403":"80a1c1fe","mobileExploreCategoryPage":"cfe0b8f2","mobileExploreResultsPage-mobileSearchResultsPage":"41dd2a61","mobileExploreResultsPage":"7020995e","mobileSearchResultsPage":"a9e1c6ed","mobileFavoritesPage":"bfb1b203","mobileResetPasswordPage":"d2534b34","mobileTrendingPage":"302fbd10","vendors-gifEditPanel-gifMakerFinalize":"0691cc7a","vendors-gifEditPanel":"6b3f9b73","gifEditPanel":"d4121394","vendors-gifMakerFinalize-mobile404-mobileChangePasswordPage-mobileChannelBranchPage-mobileChannelLea-f93ae832":"1b8820c9","gifMakerFinalize-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage":"819c54cd","mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage":"4d6aa0e7","mobileChannelBranchPage":"26c176ea","mobileChannelLeafPage":"73eb913e","mobileChannelListPage":"3f27b849","mobileChannelPage":"6e36a9a9","mobileApplyPage-mobileChangePasswordPage-mobileJoinPage-mobileLoginPage-mobileSettingsPage":"55358cf4","mobileChangePasswordPage":"67f3c788","vendors-desktopVideoDetail-desktopVideos-mobile404":"b5fa8a79","desktopVideoDetail-desktopVideos-mobile404":"20742b2a","mobile404":"86503f4c","vendors-mobileApplyPage-mobileGifMaker-mobileSettingsPage":"ad7e2ef6","vendors-gifMakerFinalize-mobileGifMaker":"e4ff50ab","vendors-mobileGifMaker":"ca4b45fd","mobileGifMaker":"1d1450e4","vendors-mobileJoinPage-mobileLoginPage":"d1d88b4f","mobileJoinPage-mobileLoginPage":"2bfb76ff","mobileJoinPage":"06f8a223","mobileLoginPage":"cb217ae7","mobileApplyPage-mobileSettingsPage":"a3684631","mobileApplyPage":"8e4550b5","mobileSettingsPage":"b293ae84","vendors-mobileDashboard":"ece50a96","mobileDashboard":"ff46bb42","vendors-mobileTeamPage":"97dabd9d","mobileTeamPage":"a0addc34","vendors-showdown":"5a93ff52","desktopVideoDetail":"4f6f99b7","desktopVideos":"246e98a7","creationAnimate":"efa73b61","creationCutOut":"f8935945","desktopUploadFinalize":"32b62998","gifMakerSlideshow":"45d0181c","gifMakerVideoTrim":"436e1d44","gifMakerFinalize":"c24d41d0","aboutPage":"ec8a9606","appsLanding":"f3bc5fd8","artists":"b4790408","curationStation":"18df56ff","desktopChannelStories":"004fe4e6","desktopStory":"c98cf74b","homebase":"2d9cf5e8","homepageBeta":"76598cf7"}[chunkId] + ".bundle.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/static/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
